/**
 * Gate that delays tenant-scoped GraphQL operations until the active tenant
 * has been determined. OperatorMe (bootstrap) bypasses the gate because it
 * populates the tenant list.
 */

const BOOTSTRAP_OPERATION_ALLOWLIST: ReadonlySet<string> = new Set(['OperatorMe']);

let pending: { promise: Promise<void>; resolve: () => void };

function arm(): void {
  let resolve!: () => void;
  const promise = new Promise<void>((r) => {
    resolve = r;
  });
  pending = { promise, resolve };
}

arm();

export function whenTenantResolved(): Promise<void> {
  return pending.promise;
}

export function markTenantResolved(): void {
  pending.resolve();
}

export function resetTenantResolved(): void {
  arm();
}

export function isBootstrapOperation(operationName?: string): boolean {
  return !!operationName && BOOTSTRAP_OPERATION_ALLOWLIST.has(operationName);
}
